import { Component } from '@angular/core';

@Component({
  selector: 'app-close-light-svg',
  standalone: true,
  template: `<svg
    version="1.2"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 330 331"
    width="20"
    height="20"
  >
    <title>close (1)-svg</title>
    <style>
      .s0 {
        fill: #ffffff;
      }
    </style>
    <path
      id="Layer"
      class="s0"
      d="m194.8 165.8l128.2-128.2c8.4-8.4 8.4-21.9 0-30.2-8.3-8.3-21.8-8.3-30.2 0l-128.2 128.2-128.2-128.2c-8.3-8.3-21.8-8.3-30.1 0-8.4 8.3-8.4 21.8 0 30.2l128.2 128.2-128.2 128.2c-8.4 8.3-8.4 21.8 0 30.1 4.1 4.2 9.6 6.3 15 6.3 5.5 0 11-2.1 15.1-6.3l128.2-128.2 128.2 128.2c4.2 4.2 9.7 6.3 15.1 6.3 5.5 0 11-2.1 15.1-6.3 8.4-8.3 8.4-21.8 0-30.1z"
    />
  </svg>`,
})
export class CloseLightSvgComponent {}
